import LimitIncreaseAddressDocument from "./LimitIncreaseAddressDocument";
import LimitIncreaseSourceOfIncome from "./LimitIncreaseSourceOfIncome";

const JSON_KEY_ID = "id";
const JSON_KEY_REGISTRATION_ID = "registration-id";
const JSON_KEY_REQUEST_DATE = "request-date";
const JSON_KEY_STATUS = "status";
const JSON_KEY_STATUS_DISPLAY = "status-display";
const JSON_KEY_ADDRESS_DOCUMENTS = "address-documents";
const JSON_KEY_SOURCES_OF_INCOME = "sources-of-income";

export default class LimitIncrease {

    constructor(jsonResponse) {

        this.id = jsonResponse[JSON_KEY_ID];
        this.registrationId = jsonResponse[JSON_KEY_REGISTRATION_ID];
        this.requestDate = jsonResponse[JSON_KEY_REQUEST_DATE];
        this.status = jsonResponse[JSON_KEY_STATUS];
        this.statusDisplay = jsonResponse[JSON_KEY_STATUS_DISPLAY];

        this.addressDocuments = [];
        if (Array.isArray(jsonResponse[JSON_KEY_ADDRESS_DOCUMENTS])) {
            jsonResponse[JSON_KEY_ADDRESS_DOCUMENTS].forEach(addressDocument => {
                this.addressDocuments.push(new LimitIncreaseAddressDocument(addressDocument));
            })
        }

        this.sourcesOfIncome = [];
        if (Array.isArray(jsonResponse[JSON_KEY_SOURCES_OF_INCOME])) {
            jsonResponse[JSON_KEY_SOURCES_OF_INCOME].forEach(sourceOfIncome => {
                this.sourcesOfIncome.push(new LimitIncreaseSourceOfIncome(sourceOfIncome));
            })
        }
    }
}
